import React from 'react';
import * as Styled from './styled';

type ReviewItemProps = {
  children?: never;
  value: string | boolean;
  label: string;
  isUpperCase?: boolean;
};

const ReviewItem: React.FC<ReviewItemProps> = ({ value, label, isUpperCase }) => (
  <Styled.ReviewItemWrapper>
    <Styled.Label>{label}</Styled.Label>
    {!isUpperCase && (
      <Styled.Value data-testid={`review-value-${label.toLowerCase().replace(/\s/g, '-')}`}>
        {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value}
      </Styled.Value>
    )}
    {isUpperCase && (
      <Styled.ValueUpperCase
        data-testid={`review-value-${label.toLowerCase().replace(/\s/g, '-')}`}>
        {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value}
      </Styled.ValueUpperCase>
    )}
  </Styled.ReviewItemWrapper>
);

export default ReviewItem;
